export default __webpack_public_path__ + "media/images/user_photos/165-b6318fd0959bd7380957b64e354f1711.jpg";